import * as about from './definitions/about';
import * as account from './definitions/account';
import * as allMembers from './definitions/all-members';
import * as blogComments from './definitions/blog-comments';
import * as blogLikes from './definitions/blog-likes';
import * as blogPosts from './definitions/blog-posts';
import * as fileShare from './definitions/file-share';
import * as followers from './definitions/followers';
import * as followersLightbox from './definitions/followers-lightbox';
import * as forumComments from './definitions/forum-comments';
import * as forumPosts from './definitions/forum-posts';
import * as groups from './definitions/groups';
import * as myAddresses from './definitions/my-addresses';
import * as myBookings from './definitions/my-bookings';
import * as myBookingsPage from './definitions/my-bookings-page';
import * as myChallenges from './definitions/my-challenges';
import * as myDrafts from './definitions/my-drafts';
import * as myEvents from './definitions/my-events';
import * as myOrders from './definitions/my-orders';
import * as myPosts from './definitions/my-posts';
import * as myPrograms from './definitions/my-programs';
import * as myRewards from './definitions/my-rewards';
import * as mySubscriptions from './definitions/my-subscriptions';
import * as myWallet from './definitions/my-wallet';
import * as myWishlist from './definitions/my-wishlist';
import * as notifications from './definitions/notifications';
import * as notificationsPage from './definitions/notifications-page';
import * as memberPage from './definitions/pages/member-page';
import * as memberSettingsPage from './definitions/pages/member-settings-page';
import * as settings from './definitions/settings';
import * as sharedGallery from './definitions/shared-gallery';
import * as testVerticalPrivateWidget from './definitions/test-vertical-private-widget';
import * as testVerticalPublicWidget from './definitions/test-vertical-public-widget';
export const membersAreaApps = [
    about,
    allMembers,
    followers,
    followersLightbox,
    forumComments,
    forumPosts,
    notifications,
    notificationsPage,
    settings,
    account,
    blogComments,
    blogLikes,
    blogPosts,
    fileShare,
    myAddresses,
    myBookings,
    myBookingsPage,
    myDrafts,
    myPosts,
    myEvents,
    myOrders,
    myWallet,
    myWishlist,
    sharedGallery,
    mySubscriptions,
    myChallenges,
    myPrograms,
    myRewards,
    memberPage,
    memberSettingsPage,
    groups,
    testVerticalPublicWidget,
    testVerticalPrivateWidget,
];
//# sourceMappingURL=index.js.map